export enum EntidadeEnum {
  UDEMO = 'UDEMO',
  UNIMED_FESP = 'UNIMEDFESP',
  APASE = 'APASE',
  ABRAWEB = 'ABRAWEB',
  ABJE = 'ABJE',
  ADSERVIP = 'ADSERVIP',
  AFUSPEN = 'AFUSPEN',
  CPP = 'CPP',
  CROSP = 'CROSP',
  SASP = 'SASP',
  SINDINUTRI = 'SINDINUTRI',
  TECNOLOGOS = 'TECNOLOGOS',
  AASTPJ = 'AASTPJ',
}

export class EntidadeConfig {
  static getConfig(entidade: string) {
    const entidadeUpper = entidade?.toUpperCase();

    // Retorno base para todas as entidades
    const baseReturn = {
      tipo: entidadeUpper,
      nomeCompleto: this.getNomeCompleto(entidadeUpper),
    };

    // Retorna o objeto com as flags específicas de cada entidade
    switch (entidadeUpper) {
      case EntidadeEnum.UDEMO:
        return {...baseReturn, heUdemo: true};
      case EntidadeEnum.UNIMED_FESP:
        return {...baseReturn, heUnimedFesp: true};
      case EntidadeEnum.APASE:
        return {...baseReturn, heApase: true};
      case EntidadeEnum.ABRAWEB:
        return {...baseReturn, heAbraWeb: true};
      case EntidadeEnum.ABJE:
        return {...baseReturn, heAbje: true};
      case EntidadeEnum.ADSERVIP:
        return {...baseReturn, heAdservip: true};
      case EntidadeEnum.AFUSPEN:
        return {...baseReturn, heAfuspen: true};
      case EntidadeEnum.CPP:
        return {...baseReturn, heCpp: true};
      case EntidadeEnum.CROSP:
        return {...baseReturn, heCrosp: true};
      case EntidadeEnum.SASP:
        return {...baseReturn, heSasp: true};
      case EntidadeEnum.SINDINUTRI:
        return {...baseReturn, heSindinutri: true};
      case EntidadeEnum.TECNOLOGOS:
        return {...baseReturn, heTecnologos: true};
      case EntidadeEnum.AASTPJ:
        return {...baseReturn, heAastpj: true};
      default:
        return {...baseReturn, heOutra: true};
    }
  }

  // Método auxiliar para obter o nome completo da entidade
  private static getNomeCompleto(tipo: string): string {
    const nomes: {[key: string]: string} = {
      [EntidadeEnum.UDEMO]: 'União dos Docentes do Estado de Minas Gerais',
      [EntidadeEnum.UNIMED_FESP]:
        'Unimed Federação das Empresas de Serviços de Saúde do Estado de São Paulo',
      [EntidadeEnum.APASE]: 'Associação Paulista de Cirurgiões-Dentistas',
      [EntidadeEnum.ABRAWEB]: 'Associação Brasileira de Profissionais Web',
      [EntidadeEnum.ABJE]: 'Associação Brasileira de Jornalistas Esportivos',
      [EntidadeEnum.ADSERVIP]:
        'Associação dos Servidores Públicos do Estado de São Paulo',
      [EntidadeEnum.AFUSPEN]:
        'Associação dos Funcionários Públicos do Estado do Espírito Santo',
      [EntidadeEnum.CPP]: 'Centro do Professorado Paulista',
      [EntidadeEnum.CROSP]: 'Conselho Regional de Odontologia de São Paulo',
      [EntidadeEnum.SASP]: 'Sociedade de Análise de Sistemas do Paraná',
      [EntidadeEnum.SINDINUTRI]:
        'Sindicato dos Nutricionistas do Estado de São Paulo',
      [EntidadeEnum.TECNOLOGOS]:
        'Sindicato dos Tecnólogos do Estado de São Paulo',
      [EntidadeEnum.AASTPJ]: 'Associação dos Advogados de São Paulo',
    };

    return nomes[tipo] || 'Outra Entidade';
  }

  // Método auxiliar para verificar se uma entidade é UDEMO
  static isUdemo(entidade: string): boolean {
    return entidade?.toUpperCase() === EntidadeEnum.UDEMO;
  }

  // Método auxiliar para verificar se uma entidade é UNIMED FESP
  static isUnimedFesp(entidade: string): boolean {
    return entidade?.toUpperCase() === EntidadeEnum.UNIMED_FESP;
  }

  // Método auxiliar para verificar se uma entidade é APASE
  static isApase(entidade: string): boolean {
    return entidade?.toUpperCase() === EntidadeEnum.APASE;
  }

  // Método auxiliar para verificar se uma entidade é ABRAWEB
  static isAbraweb(entidade: string): boolean {
    return entidade?.toUpperCase() === EntidadeEnum.ABRAWEB;
  }

  // Método auxiliar para verificar se uma entidade é ABJE
  static isAbje(entidade: string): boolean {
    return entidade?.toUpperCase() === EntidadeEnum.ABJE;
  }

  // Método auxiliar para verificar se uma entidade é ADSERVIP
  static isAdservip(entidade: string): boolean {
    return entidade?.toUpperCase() === EntidadeEnum.ADSERVIP;
  }

  // Método auxiliar para verificar se uma entidade é AFUSPEN
  static isAfuspen(entidade: string): boolean {
    return entidade?.toUpperCase() === EntidadeEnum.AFUSPEN;
  }

  // Método auxiliar para verificar se uma entidade é CPP
  static isCpp(entidade: string): boolean {
    return entidade?.toUpperCase() === EntidadeEnum.CPP;
  }

  // Método auxiliar para verificar se uma entidade é CROSP
  static isCrosp(entidade: string): boolean {
    return entidade?.toUpperCase() === EntidadeEnum.CROSP;
  }

  // Método auxiliar para verificar se uma entidade é SASP
  static isSasp(entidade: string): boolean {
    return entidade?.toUpperCase() === EntidadeEnum.SASP;
  }

  // Método auxiliar para verificar se uma entidade é SINDINUTRI
  static isSindinutri(entidade: string): boolean {
    return entidade?.toUpperCase() === EntidadeEnum.SINDINUTRI;
  }

  // Método auxiliar para verificar se uma entidade é TECNOLOGOS
  static isTecnologos(entidade: string): boolean {
    return entidade?.toUpperCase() === EntidadeEnum.TECNOLOGOS;
  }

  // Método auxiliar para verificar se uma entidade é AASTPJ
  static isAastpj(entidade: string): boolean {
    return entidade?.toUpperCase() === EntidadeEnum.AASTPJ;
  }
}

// Interface para tipar o retorno do getConfig
export interface EntidadeConfigType {
  tipo: string;
  nomeCompleto: string;
  heUdemo?: boolean;
  heUnimedFesp?: boolean;
  heApase?: boolean;
  heAbraWeb?: boolean;
  heAbje?: boolean;
  heAdservip?: boolean;
  heAfuspen?: boolean;
  heCpp?: boolean;
  heCrosp?: boolean;
  heSasp?: boolean;
  heSindinutri?: boolean;
  heTecnologos?: boolean;
  heAastpj?: boolean;
  heOutra?: boolean;
  [key: string]: any; // Para permitir acesso dinâmico às propriedades
}

export type EntidadeReturnType = EntidadeConfigType & {
  tipo: string;
  nomeCompleto: string;
};
